package org.hs_soft.runmynesto.data.api_datasource.options.export

import kotlinx.serialization.json.Json
import kotlinx.serialization.json.buildJsonObject
import kotlinx.serialization.json.put
import kotlinx.serialization.json.putJsonObject
import org.hs_soft.runmynesto.data.api_datasource.RequestManager
import org.hs_soft.runmynesto.domain.ApiClient
import org.hs_soft.runmynesto.domain.config.Errors
import org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.pms_config.apaleo_properties.ApaleoPropertieModel
import org.hs_soft.runmynesto.domain.model.home.options.export.apaleo_sub_account.ApaleoSubAccountModel
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.export.ApaleoSubAccountRepository
import org.hs_soft.runmynesto.domain.util.ApiUtils

class ApaleoSubAccountRepositoryImpl(
    private val apiClient: ApiClient,
    private val requestManager: RequestManager
) : ApaleoSubAccountRepository {
    
    override suspend fun apaleoSubAccounts(propertyId: String):
            ApaleoSubAccountModel
    {
        val abortController = requestManager.createController()
        
        val graphQLQuery = buildJsonObject {
            put(
                "query", """
                    query apaleoSubAccounts(${'$'}propertyId: ID!) {
                      cashAssist {
                        listApaleoSubAccounts(propertyId: ${'$'}propertyId) {
                          ${ApiUtils.Field.id}
                          ${ApiUtils.Field.name}
                          ${ApiUtils.Field.salesGroupIds}
                          ${ApiUtils.Field.type}
                          ${ApiUtils.Field.__typename}
                        }
                        ${ApiUtils.Field.__typename}
                      }
                    }
                """.trimIndent()
            )
            
            putJsonObject("variables") {
                put("propertyId", propertyId)
            }
        }

        val result = apiClient.requestResult(
            graphQLQuery = graphQLQuery,
            resource = ApiUtils.Cognito.API_URL,
            abortController = abortController,
        )

        return if (result != null) {
            Json.decodeFromString(result.decodeToString())
        } else {
            throw Exception(Errors.timeoutErr)
        }
    }
} 